export const config = {
  pageSize: 25,
} as const
